module.exports = __webpack_public_path__ + "static/stielwindlicht-blau.2b4ebaa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/stielwindlicht-blau.jpg
// module id = 552
// module chunks = 35783957827783